type FontName = 'black' | 'book' | 'heavy' | 'light' | 'medium' | 'roman' | 'dmSansBold';

export const fontNames: Record<FontName, string> = {
    book: 'Avenir-Book',
    black: 'Avenir-Black',
    heavy: 'Avenir-Heavy',
    light: 'Avenir-Light',
    medium: 'Avenir-Medium',
    roman: 'Avenir-Roman',

    dmSansBold: 'DMSans-Bold',
};
